// extracted by mini-css-extract-plugin
module.exports = {"table":"styles__table--24gLW","editButton":"styles__editButton--4uDLs"};